interface Feedback {
  like: number;
  dislike: number;
}

export interface FeedbackState extends Feedback {
  status: boolean | null | undefined;
}

export interface ICommentContent {
  id: number;
  content: string;
  created_at: string;
  last_edited_on: string | null;
  navigation_id: string;
  parent: CommentResult | null;
  post: number;
  updated_at: string;
  username: string;
}
export interface CommentResult {
  content: string;
  created_at: string;
  feedback?: Feedback;
  id: number;
  last_edited_on?: string | null;
  liked?: boolean | null;
  navigation_id: string;
  parent: CommentResult | null;
  post: number;
  reply_count?: number;
  reported?: boolean;
  updated_at: string;
  username: string;
}

export interface IParentProps {
  count: number;
  next: string | null;
  previous: string | null;
  total_count?: number;
  results: CommentResult[];
}

export interface ICommentCard {
  commentData: CommentResult | undefined;
  isLoggedIn: boolean;
}

export interface IContent {
  content: string;
  reported: boolean | undefined;
  last_edited_on: string | null | undefined;
}

export interface IPropsCommentBox {
  parentId?: number | null;
  type?: number;
  isParentComment?: boolean;
  content?: IContent;
  setCommentContent?: (value: IContent) => void;
  setDisplayActionModal?: (value: boolean) => void;
  setEdited?: (value: boolean) => void;
  commentId?: number;
  replies?: IParentProps;
  setReplies?: (value: IParentProps) => void;
}

interface IActionHandlder {
  content: IContent;
  setCommentContent: (value: IContent) => void;
  commentId: number;
  setDisplayActionModal: (value: boolean) => void;
}
export enum ActionTypes {
  CreateParentComment = 1,
  CreateRepliesComment = 2,
  EditComment = 3,
}

export enum StatusType {
  Derogatory = 'derogatory',
  Failed = 'failed',
  Success = 'success',
  Duplicate = 'duplicate',
}

export enum ActionButtonTypes {
  Delete = 'Delete',
  Report = 'Report',
}
export interface IActionApiCallParams {
  targetId: string;
  actionObj: IActionHandlder;
  replies?: IParentProps;
  setReplies?: (value: IParentProps) => void;
}
